import React from "react";
import { Box, Typography } from "@mui/material";
import tmsDriverimageDownload from "assets/tmsDriverimageDownload.png"
import AppStoreButtons from "assets/AppStoreButtons.png";
import GooglePlayButtons from "assets/GooglePlayButtons.png";

const DownloadTMSDriverCard = () => {
    return (
        <Box
            sx={{
                mt: 2,
                mx: 2,
                p: 2,
                borderRadius: 2,
                bgcolor: "background.paper",
                boxShadow: 1,
                textAlign: "center",
            }}
        >
            <Typography variant="subtitle1" fontWeight={600} mb={1}>
                Download TMS Driver App
            </Typography>

            <Box
                component="img"
                src={tmsDriverimageDownload}
                alt="TMS Vendor"

                sx={{
                    width: "70%",
                    borderRadius: 8,
                    mb: 2,
                    mx: "auto"
                }}
            />

            <Box>
                <Box
                    component="a"
                    href="https://apps.apple.com/app/tcb-tms-driver/id6751702827"
                    target="_blank"
                    rel="noopener noreferrer"
                    display="block"
                    mb={1}
                >
                    <Box
                        component="img"
                        src={AppStoreButtons}
                        alt="Download on the App Store"
                        sx={{ width: "120px", mx: "auto" }}
                    />
                </Box>

                <Box
                    component="a"
                    href="https://play.google.com/store/apps/details?id=com.thecanbrand.tmsDriver"
                    target="_blank"
                    rel="noopener noreferrer"
                    display="block"
                >
                    <Box
                        component="img"
                        src={GooglePlayButtons}
                        alt="Get it on Google Play"
                        sx={{ width: "120px", mx: "auto" }}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default DownloadTMSDriverCard;
